<template>
  <div class="social-wrapper  d-flex flex-wrap">
    <a @click="showIcons = !showIcons" class="btn-social small"><span class="social-text me-2">Delen:</span> <font-awesome-icon class="open-social-icon" :icon="['fas', 'share-nodes']" size="xl" /></a>
    <transition name="socialAnim">
      <div class="social-icon-group ms-3" role="group" aria-label="Social share" v-show="showIcons">
        <a target="_blank" class="me-2 social-share-btn icon-facebook small" :href="facebookShare"><font-awesome-icon class="social-icon" :icon="['fab', 'facebook']" size="2xl"/></a>
        <a target="_blank" class="me-2 social-share-btn icon-x-twitter small" :href="twitterShare"><font-awesome-icon class="social-icon" :icon="['fab', 'x-twitter']" size="2xl"/></a>
        <a target="_blank" class="me-2 social-share-btn icon-linkedin small" :href="linkedinShare"><font-awesome-icon class="social-icon" :icon="['fab', 'linkedin']" size="2xl"/></a>
        <a target="_blank" class="me-2 social-share-btn icon-whatsapp small" :href="whatsAppShare"><font-awesome-icon class="social-icon" :icon="['fab', 'whatsapp']" size="2xl"/></a>
        <a target="_blank" class="social-share-btn icon-mail small" :href="mailShare"><font-awesome-icon class="social-icon" icon="envelope" size="2xl" /></a>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'SocialShare',
  props: {
    car:Object,
    currentModel: String
  },
  methods: {

  },
  data(){
    return {
      domainUrl:'',
      carUrl:'',
      showIcons:false,
      showToolTip:false,
      facebookShare:'',
      twitterShare:'',
      linkedinShare:'',
      whatsAppShare:'',
      mailShare:'',
    }
  },
  mounted() {
    this.domainUrl = window.location.origin; // var is being watched
  },
  watch: {
    domainUrl: function() {
      // when domainUrl is known
      this.carUrl = this.domainUrl + '/aanbod/' + this.currentModel;
      this.facebookShare = encodeURI('https://www.facebook.com/sharer.php?u=' + this.carUrl);
      this.twitterShare = encodeURI('https://twitter.com/intent/tweet?url=' + this.carUrl + '&text=' + this.car.title + ' - ' + this.car.extradata.type);
      this.linkedinShare = encodeURI('https://www.linkedin.com/shareArticle?mini=true&url=' + this.carUrl + '&title=' + this.car.title + '&summary=' + this.car.title + ' - ' + this.car.extradata.type);
      this.whatsAppShare = encodeURI('https://wa.me/?text=' + this.car.title + ': ' + this.carUrl);
      // avoided encoding mail share link, new enter lines wont work.
      this.mailShare = 'mailto:?subject=Ik wil deze auto met je delen: ' + this.car.title + ' - ' + this.car.extradata.type + '&body=' + this.car.title + '%0D%0A' + this.car.extradata.type + '%0D%0A%0D%0ABekijk de auto op:%0D%0A' + this.carUrl;
    }
  },
};
</script>

<style lang="scss">
.social-wrapper{
  padding: 20px 10px;
}
.btn-social, .btn-social:hover {
  background-color: #EE1D1D;
  color: #fff !important;
  padding: 0.375rem 0.85rem;
  border-radius: 50px;
  font-size: 14px;
  line-height: 20px;
  position: relative;
  display: inline-flex;
  align-items: center;
  transition: all .3s;
  cursor: pointer;
  text-decoration: none !important;
  &:hover{
    opacity: .8;
    //transform: translateY(-5px)
  }
}
.social-share-btn{
  width: 38px;
  height: 38px;
  background: white;
  display: inline-flex;
  position: relative;
  border-radius: 4px;
  transition: all .3s;
  &.icon-whatsapp:hover{
    background: #32D14F;
    .social-icon {
      color: white !important;
    }
  }
  &.icon-linkedin:hover{
    background: #0173B1;
    .social-icon {
      color: white !important;
    }
  }
  &.icon-facebook:hover{
    background: #0071F3;
    .social-icon {
      color: white !important;
    }
  }
  &.icon-x-twitter:hover{
    background: white;
    .social-icon {
      color: black !important;
    }
  }
  &.icon-mail:hover{
    background: #007DD3;
    .social-icon {
      color: white !important;
    }

  }
  .social-icon{
    margin: 6px auto;
    display: block;
    color: #EE1D1D;
  }
  &:hover{
    opacity: .8;
    transform: translateY(-1px);
    fill: white !important;
  }
}
.social-icon-group {
  background-color: transparent;
  flex-flow: row wrap;
  position: relative;
  height: 38px;
  top: 0px;
}
.socialAnim-enter-active {
  animation: social-in 0.25s;
}
.socialAnim-leave-active {
  animation: social-in 0.3s reverse;
}
// animation for social wrapper
@keyframes social-in {
  0% {opacity: 0;}
  100% {opacity: 1;}
}
.fa-2xl{
  font-size: 28px !important;
 }
.fa-xl{
  font-size: 1.8em !important;
}
@media only screen and (max-width:767px) {
  .btn-social{
    &.small{
      padding: 10px 14px;
      border-radius: 100%;
      height: 40px;
      width: 40px;
      .open-social-icon{
        display: block;
        position: relative;
        right: 6px;
      }
    }
  }
  .social-share-btn {
    width: 34px;
    height: 34px;
    background: white;
    display: inline-flex;
    position: relative;
    border-radius: 4px;
    transition: all .3s;
    .social-icon {
      margin: 5px auto;
      display: block;
    }
  }
  .social-text{
    display: none;
  }
  .social-icon-group {
    top: 2px;
    height: 34px;
  }
  .fa-xl{
    font-size: 1.5em !important;
  }
  .fa-2xl{
    font-size: 24px !important;
  }
}
</style>
